import { MENU_VISIBILITY_CONFIG } from "../config/menuVisibility";

const COMMERCIAL_INTELLIGENCE_PREFIX = "/commercial-intelligence";

export const COMMERCIAL_INTELLIGENCE_PATHS = {
  articleGroups: `${COMMERCIAL_INTELLIGENCE_PREFIX}/configuration/article-groups`,
  campaigns: `${COMMERCIAL_INTELLIGENCE_PREFIX}/campaigns`,
  clientLevels: `${COMMERCIAL_INTELLIGENCE_PREFIX}/configuration/client-levels`,
  clients: `${COMMERCIAL_INTELLIGENCE_PREFIX}/clients`,
  dashboard: `${COMMERCIAL_INTELLIGENCE_PREFIX}/dashboard`,
  incentives: `${COMMERCIAL_INTELLIGENCE_PREFIX}/opportunities/incentives`,
  promotions: `${COMMERCIAL_INTELLIGENCE_PREFIX}/opportunities/promotions`,
  rewardTypes: `${COMMERCIAL_INTELLIGENCE_PREFIX}/configuration/reward-types`,
  segments: `${COMMERCIAL_INTELLIGENCE_PREFIX}/segments`,
  tickets: `${COMMERCIAL_INTELLIGENCE_PREFIX}/tickets`,
  units: `${COMMERCIAL_INTELLIGENCE_PREFIX}/configuration/units`,
};

const FIDELITY_MENU_ALIASES: [string, string][] = [
  ["/fidelity/dashboard", COMMERCIAL_INTELLIGENCE_PATHS.dashboard],
  ["/fidelity/clients", COMMERCIAL_INTELLIGENCE_PATHS.clients],
  ["/fidelity/clientsegments", COMMERCIAL_INTELLIGENCE_PATHS.segments],
  ["/fidelity/clientlevels", COMMERCIAL_INTELLIGENCE_PATHS.clientLevels],
  ["/fidelity/tickets", COMMERCIAL_INTELLIGENCE_PATHS.tickets],
  ["/fidelity/rewards", COMMERCIAL_INTELLIGENCE_PATHS.incentives],
  ["/fidelity/rewardtypes", COMMERCIAL_INTELLIGENCE_PATHS.rewardTypes],
  ["/fidelity/units", COMMERCIAL_INTELLIGENCE_PATHS.units],
  ["/fidelity", COMMERCIAL_INTELLIGENCE_PREFIX],
];

const PROMOTIONS_MENU_ALIASES: [string, string][] = [
  ["/promotions/dashboard", COMMERCIAL_INTELLIGENCE_PATHS.dashboard],
  ["/promotions/clients", COMMERCIAL_INTELLIGENCE_PATHS.clients],
  ["/promotions/clientsegments", COMMERCIAL_INTELLIGENCE_PATHS.segments],
  ["/promotions/clientlevels", COMMERCIAL_INTELLIGENCE_PATHS.clientLevels],
  ["/promotions/tickets", COMMERCIAL_INTELLIGENCE_PATHS.tickets],
  ["/promotions/campaigns", COMMERCIAL_INTELLIGENCE_PATHS.campaigns],
  ["/promotions/articlegroups", COMMERCIAL_INTELLIGENCE_PATHS.articleGroups],
  ["/promotions", COMMERCIAL_INTELLIGENCE_PATHS.promotions],
];

const getMenuAliases = (): [string, string][] =>
  MENU_VISIBILITY_CONFIG.modules.fidelity
    ? PROMOTIONS_MENU_ALIASES
    : [...FIDELITY_MENU_ALIASES, ...PROMOTIONS_MENU_ALIASES];

export const getMenuPathname = (pathname: string) => {
  const alias = getMenuAliases().find(
    ([legacyPrefix]) =>
      pathname === legacyPrefix || pathname.startsWith(`${legacyPrefix}/`)
  );
  if (!alias) {
    return pathname;
  }
  const [legacyPrefix, menuPrefix] = alias;
  return `${menuPrefix}${pathname.slice(legacyPrefix.length)}`;
};
